var _defs, _path, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _line, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.64 8.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0b5ed6;\n        stroke-miterlimit: 10;\n        stroke-width: .3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.38,1.02c0-.15,0-.32,0-.48,0-.14,0-.27,0-.38H.19c0,.13,0,.3,0,.43,0,.14,0,.29-.01.44"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.05 .59 8.58 .58 8.58 .58"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.21 .59 9.73 .58 9.74 .58"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.33 .59 10.85 .58 10.85 .58"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.77 3.74 7.37 3.73 7.37 3.73"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.77 5.17 6.85 5.17 6.85 5.17"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.85,
    y1: 6.72,
    x2: 1.53,
    y2: 6.72
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.39,5.67c-.38-.07-.67-.4-.67-.8s.29-.73.67-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.26,7.75s-.07-.03-.07-.07l-.07-.7-.69-.14-.38.52s-.03.03-.05.03c-.02,0-.04,0-.06-.02l-.86-.76s-.02-.03-.02-.05c0-.02,0-.04.02-.05l.48-.5-.26-.71-.63-.13s-.04-.02-.05-.03c-.01-.02-.01-.04,0-.06l.3-1.23s.02-.04.04-.05c.02,0,.04-.01.06,0l.52.17.51-.6-.4-.58s-.02-.04-.01-.06c0-.02.02-.04.04-.05l1.04-.58s.04-.01.06,0c.02,0,.03.02.04.04l.32.65h.29c0-.6,0-1.2-.01-1.81-1.57,0-3.17-.02-4.71,0-2.13.03-4.33.02-6.5,0-.02,1.69-.01,3.41,0,5.01,0,.79,0,1.6,0,2.41,1.88,0,3.78,0,5.62,0,1.83,0,3.73,0,5.59,0,0-.22,0-.43,0-.65h-.12s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.54,4.05s0,0,0,0c.45,0,.82.37.82.82s-.37.82-.82.82c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.39,2.78h-.29s-.32-.65-.32-.65c0-.02-.02-.03-.04-.04-.02,0-.04,0-.06,0l-1.04.58s-.03.03-.04.05c0,.02,0,.04.01.06l.4.58-.51.6-.52-.17s-.04,0-.06,0c-.02,0-.03.03-.04.05l-.3,1.23s0,.04,0,.06c.01.02.03.03.05.03l.63.13.26.71-.48.5s-.02.03-.02.05c0,.02,0,.04.02.05l.86.76s.04.02.06.02c.02,0,.04-.01.05-.03l.38-.52.69.14.07.7s.04.07.07.07c0,0,0,0,0,0h.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.53,7.73l.79-.05s.04-.01.05-.03c.01-.02.02-.04.02-.06l-.09-.64.52-.34.54.49s.03.02.05.02c.02,0,.04-.01.05-.03l.79-.97s.02-.04.02-.06c0-.02-.02-.04-.04-.05l-.66-.38.07-.54.8-.22s.04-.02.04-.04c0-.02.01-.04,0-.06l-.34-1.12s-.02-.03-.04-.04c-.02,0-.04-.01-.06,0l-.68.22-.43-.63.38-.66s.01-.04,0-.06c0-.02-.02-.04-.04-.04l-1.02-.46s-.04,0-.06,0c-.02,0-.03.02-.04.04l-.3.75h-.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.53,5.68s0,0,0,0c.45,0,.82-.37.82-.82s-.37-.82-.82-.82c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.39,4.06c-.38.07-.67.4-.67.8s.29.73.67.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.54,
    y1: 2.78,
    x2: 11.39,
    y2: 2.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.39,5.67s.1.01.15.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.54,4.05c-.05,0-.1,0-.15.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.38,
    y1: 7.74,
    x2: 11.53,
    y2: 7.73
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.69,2.36c0,.71,0,1.43,0,2.1,0,.33,0,.66,0,.99.46,0,.91,0,1.37,0,.45,0,.91,0,1.36,0,0-.37,0-.72,0-1.06,0-.69,0-1.34,0-2.03-.38,0-.76,0-1.14,0-.52.01-1.06,0-1.59,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/Icon 14.0c518972a7a2c6c4cd7001ef721dfb1f.svg";
export { ForwardRef as ReactComponent };